import { AuthEventData } from '@aws-amplify/ui';
import { AmplifyUser } from '@aws-amplify/ui/dist/types/types/authenticator/user';

import Logo from 'assets/images/oc-green-logo.svg';
import { ROOT_PATH } from 'constants/paths';

function Header({
  user,
  signOut
}: {
  user?: AmplifyUser | undefined;
  signOut?: ((data?: AuthEventData | undefined) => void) | undefined;
}): JSX.Element {
  return (
    <nav className="px-8 py-2 bg-white text-gray-700 drop-shadow-md flex items-center text-sm">
      <div className="flex flex-1"></div>
      <a href={ROOT_PATH}>
        <img src={Logo} />
      </a>
      <div className="flex flex-1 justify-end">
        {user != null && (
          <>
            <span>{user?.attributes?.email}</span>&nbsp;•&nbsp;
            <a className="cursor-pointer" onClick={signOut}>
              Sign out
            </a>
          </>
        )}
      </div>
    </nav>
  );
}

export default Header;
